import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loyaltyService } from '../../services/loyaltyService';

export const useGetLoyaltyLevels = () => {
  return useQuery({
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
    queryKey: [QUERY_KEYS.loyalty.levels],
    queryFn: () =>
      loyaltyService.levels().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
